import { gql, useQuery } from "@apollo/client";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import styled from "styled-components";
import { UserPassword } from "../assets/User/UserPassword";
import { UserProfile } from "../assets/User/UserProfile";
import { UserWallet } from "../assets/User/UserWallet";
import MainLayoutV3 from "../components/Layouts/MainLayoutV3";
import { LoadingWLogo } from "../components/LoadingWLogo";
import ChangeEmail from "./Profile/ChangeEmail";
import ChangeMobile from "./Profile/ChangeMobile";
import ChangePassword from "./Profile/ChangePassword";
import ChangePasswordSuccess from "./Profile/ChangePasswordSuccess";
import PersonalData from "./Profile/PersonalData";
import TransactionsData from "./Profile/TransactionsData";

const StyleCss = styled.div`
  .main-box{
    background-color: var(--n-body-2);
    min-height: 70vh;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    color: var(--n-grey-9);
    .title-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.5rem;
      border-bottom: 1px solid var(--n-grey-3);
      .title {
        display: flex;
        align-items: center;
        .icon {
          padding: 12px 0;
          svg {
            width: 32px;
            height: 32px;
            display: block;
            fill: var(--n-grey-9);
          }
          .stroke {
            fill: none;
            stroke: var(--n-grey-9);
          }
        }
        .text {
          margin: 0rem 0.5rem;
          font-size: 22px;
          font-weight: 600;
          padding: 12px 0;
          height: 32px;
        }
      }
      .action {
        padding: 12px;
        margin: 0 1.5rem;
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        border-radius: 8px;
        svg {
          display: block;
          fill: var(--n-grey-7);
        }
      }
    }
  }
`;


let menuItems = [
    {
        icon: <UserProfile/>,
        title: 'Personal info',
        link: 'personal-data'
    },
    // {
    //     icon: <UserMobile/>,
    //     title: 'تغییر شماره همراه',
    //     link: 'change-mobile'
    // },
]


// get main podcast data and routes in menu
function ProfilePage(propsMain) {
  
  return (
    <MainLayoutV3 {...propsMain} type={'user'} base={'/profile'} menu={menuItems} image={''}  name={propsMain.userdata.FName + ' ' + propsMain.userdata.LName} userBalance={0}>
      <StyleCss>
        <Switch>
          <Route 
            exact
            path={`/profile/personal-data`}
            render={(props) => (
              <PersonalData {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/profile/personal-data/:edit`}
            render={(props) => (
              <PersonalData {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/profile/change-password`}
            render={(props) => (
              <ChangePassword {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/profile/change-password/success`}
            render={(props) => (
              <ChangePasswordSuccess {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/profile/transactions`}
            render={(props) => (
              <TransactionsData {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/profile/change-email`}
            render={(props) => (
              <ChangeEmail {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/profile/change-mobile`}
            render={(props) => (
              <ChangeMobile {...propsMain} {...props}/>
            )}/>
          <Route render={(props) => <Redirect to={"/profile/personal-data"} />} />
        </Switch>
      </StyleCss>
    </MainLayoutV3>
  );
}

export default ProfilePage;



//<div className="main-box">
//  <div className="title-bar">
//    <div className="title">
//      <div className="icon"><UserProfile/></div>
//      <div className="text">اطلاعات شخصی</div>
//    </div>
//    <div className="action"><Edit/></div>
//  </div>
//  <div className="content">
//  </div>
//</div>